import ApiService, {callCustomMethodAsync}  from '../service/ApiService';

let moduleApi = {};
let moduleName = "project";

moduleApi.create = async (dataForm) => { 
  let api = {
     module: moduleName,
     type: "create",
     value: dataForm
   };
   const result = await ApiService(api);
   mushroom[moduleName].invalidCache();
   return result;
 };
 
 moduleApi.update = async (dataForm) => {
   let api = {
     module: moduleName,
     type: "partialUpdate",
     value: dataForm
   };
   const result = await ApiService(api);
   mushroom[moduleName].invalidCache();
   return result;
 };

 
moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};


moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id},
    message: {
        success: "", //string | null | comment
        error: "hidden", //string | null | comment
    },
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetMyProjects = () => {
    let api = {
        module: moduleName,
        type: "GetMyProjects",
        message: {
          success: "hidden",
          error: "hidden",
        }
    };
    return callCustomMethodAsync(api);
};

moduleApi.GetProjectDetails = async (data) => {
  let api = {
    module: moduleName,
    type: "GetProjectDetails",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
  // data = {
  //  "ProjectId" : "",
  //  "IsFilter": "bool"
  //  "FilterData" :{
  //     "TypeTaskId":"",
  //      "Status":"",
  //      "AssignerID":"",
  //      "From":"Datetime",
  //      "To":"DateTime",
  //  }
  //}

  //result = {
  //    "TaskGroupList":[] {
  //      "TaskGrouId":"IdValue",
  //      "TaskGroupName":"string",
  //      "ProjectTaskList":[]{
  //        "ProjectTaskId":"IdValue",
  //        "ProjectTaskName":"string",
  //        "Type":"string",
  //        "Status":"string",
  //        "AssignerName":"string",
  //        "AssigneeNames":"string",
  //        "EndDate":"DateTime",
  //      }
  //    }
}

moduleApi.GetAllMyTasks = async (data) => {
  let api = {
    module: moduleName,
    type: "GetAllMyTasks",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
  // data = {
  //  "IsFilter": "bool"
  //  "FilterData" :{
  //     "ProjectId":"",
  //     "TypeTaskId":"",
  //      "Status":"",
  //      "AssignerID":"",
  //      "From":"Datetime",
  //      "To":"DateTime",
  //  }
  //}

  //result = {
  //    "MyProjectDto":[]{
           //"ProjectId":"IdValue",
            //"ProjectName":string
            //"TaskGroupList":[] {
            //      "TaskGrouId":"IdValue",
            //      "TaskGroupName":"string",
            //      "ProjectTaskList":[]{
            //        "ProjectTaskId":"IdValue",
            //        "ProjectTaskName":"string",
            //        "Type":"string",
            //        "Status":"string",
            //        "AssignerName":"string",
            //        "AssigneeNames":"string",
            //        "EndDate":"DateTime",
            //      }
            //    }
  //}

};


moduleApi.GetAllMyProject = () => {
  let api = {
      module: moduleName,
      type: "GetAllMyProject",
      message: {
        success: "hidden",
        error: "hidden",
      }
  };
  return callCustomMethodAsync(api);
  //result = {
  //    "MyProjectDto":[]{
            //"ProjectId":"IdValue",
            //"ProjectName":string
         //    }
  //}

};

moduleApi.DeleteProject = async (data) => {
  let api = {
    module: moduleName,
    type: "DeleteProject",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
